<template>
    <div class=" rounded-lg">
        <div class="bg-blue-white px-4 py-5 sm:p-6">
            <div class="md:justify-between md:flex w-full mb-5">
                <div class="w-1/6 flex flex-col items-start justify-start md:pt-1 pb-4 md:pb-0">
                    <div class="font-bold bg-primary-lightest border border-primary-lighter rounded-full flex justify-center items-center text-primary-darker h-8 w-8 text-xs md:text-sm">1</div>
                </div>
                <div class="w-full md:w-5/6 md:flex md:items-center">
                    <div class="md:w-1/2">
                        <label
                            class="md:text-right pr-4 block text-grey-darker text-xs sm:text-sm md:text-base font-medium mb-1 md:mb-0"
                            for="productPrice"
                        >
                            <span>{{ selectedProduct }} </span>Price <span
                                                class="w-6 h-full ml-1 flex-no-shrink inline-block align-middle"
                                                v-tooltip="{
                                                    content: 'ROI calculation applies for any currency provided that HiPhos price and Phosphate price values are in the same currency.',
                                                    show: showCurrencyTooltip
                                                }"
                                                @click="showCurrencyTooltip = !showCurrencyTooltip"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    class="icon-help stroke-current fill-none font-semibold text-primary inline-block"
                                                >
                                                    <path
                                                        class="primary"
                                                        d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"
                                                    />
                                                    <path
                                                        class="secondary fill-primary"
                                                        d="M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"
                                                    /></svg>
                                            </span>
                        </label>
                    </div>
                    <div class="md:w-1/2 flex-shrink">
                        <div class="flex flex-wrap items-stretch flex-1 relative">
                            <div class="flex -mr-px">
                                <span class="flex items-center leading-normal bg-grey-lighter rounded rounded-r-none border border-r-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm shadow-inner">USD/kg</span>
                            </div>
                            <input
                                type="number"
                                id="productPrice"
                                step="0.10"
                                v-model="productPrice"
                                class="flex-shrink flex-grow flex-auto leading-normal text-grey-darkest w-px flex-1 shadow-inner border h-10 border-grey-light rounded rounded-l-none px-3 relative"
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div class="md:justify-between md:flex w-full border-t border-grey-light pt-5">
                <div class="w-1/6 flex flex-col items-start justify-start md:pt-1 pb-4 md:pb-0">
                    <div class="font-bold bg-primary-lightest border border-primary-lighter rounded-full flex justify-center items-center text-primary-darker h-8 w-8 text-xs md:text-sm">2</div>
                </div>
                <div class="w-full md:w-5/6 flex flex-col">
                    <div class=" md:flex md:items-center mb-5">
                        <div class="md:w-1/2">
                            <label
                                class="md:text-right pr-4 block text-grey-darker text-xs sm:text-sm md:text-base font-medium mb-1 md:mb-0"
                                for="phospatePrice"
                            >
                                Phosphate Type
                            </label>
                        </div>
                        <div class="md:w-1/2 flex-shrink">
                            <div class="relative">
                                <select
                                    class="shadow appearance-none w-full text-xs sm:text-sm md:text-base text-grey-darkest pr-8 flex-grow leading-normal text-grey-darkest w-px flex-1 shadow-inner h-10 rounded px-3 relative cursor-pointer"
                                    :class="selectedPhosphateType == '' ? 'bg-primary-lightest border-2 border-primary-dark' : 'border border-grey-light bg-white'"
                                    id="productForm"
                                    :value="selectedPhosphateType"
                                    @change="$emit('update:selectedPhosphateType', $event.target.value)"
                                    ref="phosphateTypeInput"
                                >
                                    <option disabled hidden value="">Select phosphate</option>
                                    <option v-for="phosphateType in phosphateTypes" :key="phosphateType" :value="phosphateType" :selected="selectedPhosphateType == phosphateType">{{phosphateType}} <span>({{phosphateTypesObject != null ? phosphateTypesObject[phosphateType].fullName : ''}})</span></option>
                                </select>
                                <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
                                    <svg
                                        class="fill-current h-4 w-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                    >
                                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="md:flex md:items-center w-full mb-5">
                        <div class="md:w-1/2">
                            <label
                                class="md:text-right pr-4 block text-grey-darker text-xs sm:text-sm md:text-base font-medium mb-1 md:mb-0"
                                for="phosphatePrice"
                            >
                                Phosphate Price
                            </label>
                        </div>
                        <div class="md:w-1/2 flex-shrink">
                            <div class="flex flex-wrap items-stretch flex-1 relative">
                                <div class="flex -mr-px">
                                    <span class="flex items-center leading-normal bg-grey-lighter rounded rounded-r-none border border-r-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm shadow-inner">USD/kg</span>
                                </div>
                                <input
                                    type="number"
                                    id="phosphatePrice"
                                    step="0.01"
                                    :value="phosphatePrice"
                                    @input="$emit('update:phosphatePrice', $event.target.value)"
                                    class="flex-shrink flex-grow flex-auto leading-normal text-grey-darkest w-px flex-1 shadow-inner border h-10 border-grey-light rounded rounded-l-none px-3 relative"
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="md:justify-between md:flex w-full border-t border-grey-light pt-5">
                <div class="w-1/6 flex flex-col items-start justify-start md:pt-1 pb-4 md:pb-0">
                    <div class="font-bold bg-grey-light rounded-full border border-grey flex justify-center items-center text-grey-darker h-8 w-8 text-xs md:text-sm">3</div>
                </div>
                <div class="w-full md:w-5/6 flex flex-col">
                    <div class=" md:flex md:items-center mb-5">
                        <div class="md:w-3/5">
                            <label
                                class="md:text-right pr-4 block text-grey-dark text-xs sm:text-sm md:text-base font-medium mb-1 md:mb-0"
                                for="totalPhosphorus"
                            >
                                Total Phosphorus
                            </label>
                        </div>
                        <div class="md:w-2/5 flex-shrink">
                            <div class="flex flex-wrap items-stretch flex-1 relative">
                                <div class="flex -mr-px">
                                    <span class="flex items-center leading-normal bg-grey-lightest rounded rounded-r-none border border-r-0 border-grey-lighter px-3 whitespace-no-wrap text-grey text-sm shadow-inner">%</span>
                                </div>
                                <input
                                    type="number"
                                    id="totalPhosphorus"
                                    step="0.1"
                                    :value="totalPhosphorus"
                                    @input="$emit('update:totalPhosphorus', $event.target.value)"
                                    class="flex-shrink flex-grow flex-auto leading-normal text-grey-darker w-px flex-1 shadow-inner border h-10 border-grey-lighter rounded rounded-l-none px-3 relative"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="md:flex md:items-center w-full">
                        <div class="md:w-3/5">
                            <label
                                class="md:text-right pr-4 text-grey-dark text-xs sm:text-sm md:text-base font-medium mb-1 md:mb-0 flex justify-start md:justify-end"
                                for="availability"
                            >
                                Availability
                                <v-popover
                                    popoverBaseClass="bg-white shadow"
                                    :open="showAvailabilityTooltip"
                                    :close="showAvailabilityTooltip"
                                >
                                    <span
                                        class="w-6 h-full ml-1 flex-no-shrink inline-block align-middle"
                                        @click="showAvailabilityTooltip = !showAvailabilityTooltip"
                                        @mouseenter="showAvailabilityTooltip = true"
                                        @mouseleave="showAvailabilityTooltip = false"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            class="icon-help stroke-current fill-none font-semibold text-primary inline-block"
                                        >
                                            <path
                                                class="primary"
                                                d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"
                                            />
                                            <path
                                                class="secondary fill-primary"
                                                d="M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"
                                            /></svg>
                                    </span>
                                    <template slot="popover">
                                        <div class="max-h-10">
                                            <img src="/images/av-ph-calculation.png" alt="" class="h-12">
                                        </div>
                                    </template>
                                </v-popover>
                            </label>
                        </div>
                        <div class="md:w-2/5 flex-shrink">
                            <div class="flex flex-wrap items-stretch flex-1 relative">
                                <div class="flex -mr-px">
                                    <span class="flex items-center leading-normal bg-grey-lightest rounded rounded-r-none border border-r-0 border-grey-lighter px-3 whitespace-no-wrap text-grey text-sm shadow-inner">%</span>
                                </div>
                                <input
                                    type="number"
                                    id="availability"
                                    :value="availability"
                                    step="0.1"
                                    @input="$emit('update:availability',$event.target.value)"
                                    class="flex-shrink flex-grow flex-auto leading-normal text-grey-darker w-px flex-1 shadow-inner border h-10 border-grey-lighter rounded rounded-l-none px-3 relative"
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <transition name="fade">
            <div class="flex justify-center items-center px-4 py-5 sm:pt-12 overflow-visible" v-if="!isNaN(roi)">
                <div class="flex-1 flex justify-center bg-blue-lighter rounded-lg py-2 px-4 md:py-6 md:px-12 shadow-lg">
                    <div class="flex-no-grow pr-4 flex flex-col justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" id="line" enable-background="new 0 0 36 36" height="80px" viewBox="0 0 36 36" class=""><g><g><path d="m4.167 8.377c0 6.917-3.583 11.667-3.583 15s1.916 10.333 17.249 10.333 17.583-9.417 17.583-13.083c.001-17.167-31.249-24.5-31.249-12.25z" fill="#efefef" data-original="#EFEFEF" class=""/></g><g><path d="m28.5 8c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm0-2c-.276 0-.5.224-.5.5s.224.5.5.5.5-.224.5-.5-.224-.5-.5-.5z" fill="#a4afc1" data-original="#A4AFC1" class=""/></g><g><path d="m21.25 24.32v-15.57c0-1.105-.895-2-2-2h-10.5c-1.105 0-2 .895-2 2v15.57c0 1.105.895 2 2 2h10.5c1.105 0 2-.895 2-2z" fill="#f3f3f1" data-original="#F3F3F1" class=""/></g><g><circle cx="23.5" cy="23.5" fill="#a4d3f7" r="5.75" data-original="#a4d3f7"/></g><g><path d="m9 24.32v-15.57c0-1.105.895-2 2-2h-2.25c-1.105 0-2 .895-2 2v15.57c0 1.105.895 2 2 2h2.25c-1.105 0-2-.895-2-2z" fill="#d5dbe1" data-original="#D5DBE1" class=""/></g><g><path d="m20 23.5c0-2.79 1.988-5.115 4.625-5.638-.364-.072-.74-.112-1.125-.112-3.176 0-5.75 2.574-5.75 5.75s2.574 5.75 5.75 5.75c.385 0 .761-.039 1.125-.112-2.637-.523-4.625-2.848-4.625-5.638z" fill="#62afeb" data-original="#62afeb" class=""/></g><g><path d="m23.5 30c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-11.5c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" data-original="#000000" class="active-path" style="fill:#606F7B" data-old_color="#000000"/></g><g><path d="m22.75 25.25h1.5v2.25h-1.5z" data-original="#000000" class="active-path" style="fill:#606F7B" data-old_color="#000000"/></g><g><path d="m22.75 19.5h1.5v2.25h-1.5z" data-original="#000000" class="active-path" style="fill:#606F7B" data-old_color="#000000"/></g><g><path d="m23.625 26.5h-2.125v-1.5h2.125c.207 0 .375-.168.375-.375s-.168-.375-.375-.375h-.25c-1.034 0-1.875-.841-1.875-1.875s.841-1.875 1.875-1.875h2.125v1.5h-2.125c-.207 0-.375.168-.375.375s.168.375.375.375h.25c1.034 0 1.875.841 1.875 1.875s-.841 1.875-1.875 1.875z" data-original="#000000" class="active-path" style="fill:#606F7B" data-old_color="#000000"/></g><g><path d="m14.25 27h-5.5c-1.517 0-2.75-1.233-2.75-2.75v-15.5c0-1.517 1.233-2.75 2.75-2.75h10.5c1.517 0 2.75 1.233 2.75 2.75v5.5h-1.5v-5.5c0-.689-.561-1.25-1.25-1.25h-10.5c-.689 0-1.25.561-1.25 1.25v15.5c0 .689.561 1.25 1.25 1.25h5.5z" data-original="#000000" class="active-path" style="fill:#606F7B" data-old_color="#000000"/></g><g><path d="m10.28 18.78-1.06-1.06 2.5-2.5c.239-.24.608-.289.902-.121l1.273.728 2.846-2.627 1.018 1.103-3.25 3c-.24.222-.597.263-.881.1l-1.252-.716z" data-original="#000000" class="active-path" style="fill:#606F7B" data-old_color="#000000"/></g><g><path d="m18 17h-1.5v-2.5h-2.5v-1.5h3.25c.414 0 .75.336.75.75z" data-original="#000000" class="active-path" style="fill:#606F7B" data-old_color="#000000"/></g></g> </svg>
                    </div>
                    <div class="flex-col flex-no-grow">
                        <div class="text-lg font-semibold uppercase">ROI</div>
                        <div class="text-2xl font-medium text-primary-darker"><span class=" text-4xl font-extrabold" v-text="roi"/> / 1</div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {
    PRODUCT_DEFAULT_PRICES as productDefaultPrices,
    PHOSPHATE_DEFAULTS as phospateDefaults
} from "../utilities/application";


export default {
    props: {
        selectedProduct: String,
        selectedAnimal: String,
        ppmDose: Number,
        avPhContribution: Number,
        selectedPhosphateType: String,
        totalPhosphorus: Number,
        phosphatePrice: Number,
        availability: Number,
        hiphosPrice: Number,
        phosphateTypes: Array,
        phosphateTypesObject: Object
    },

    data() {
        return {
            productPrice: this.hiphosPrice != null ? this.hiphosPrice : _.get(productDefaultPrices, this.selectedProduct,0),
            showAvailabilityTooltip: false,
            showCurrencyTooltip: false
        };
    },

    watch: {
        selectedProduct(newValue) {
            this.productPrice = _.get(productDefaultPrices, newValue, 0);
        },

        productPrice(newValue) {
            this.$emit("update:hiphosPrice", newValue);
        },

        selectedAnimal(newValue) {
            this.$emit('update:phosphatePrice', _.get(phospateDefaults, [newValue, this.selectedPhosphateType,'price'],0));
            this.$emit('update:totalPhosphorus', _.get(phospateDefaults, [newValue, this.selectedPhosphateType,'total'],0));
            this.$emit('update:availability', _.get(phospateDefaults, [newValue, this.selectedPhosphateType,'available'],0));
        },

        phosphateReplacement(newValue, oldValue) {
            if(newValue !== oldValue) {
                this.$emit('phosphateReplacementUpdated', newValue);
            }
        },

        avP(newValue, oldValue) {
            if(newValue !== oldValue) {
                this.$emit('avPUpdated', newValue);
            }
        }
    },

    computed: {
        inclusionCost: function() {
            return (this.productPrice * this.ppmDose) / 1000;
        },

        avP: function() {
            return this.totalPhosphorus * (this.availability/100);
        },

        phosphateReplacement: function() {
            return this.avPhContribution / (this.avP/100);
        },

        phosphateReplacementValue: function() {
            return this.phosphateReplacement * this.phosphatePrice;
        },

        roi: function() {
            return _.round(this.phosphateReplacementValue / this.inclusionCost,1);
        }
    },

    methods: {
        priceUpdated() {

        },

        phosphatePriceUpdated() {

        }
    }
};
</script>

<style>

</style>